<template>
  <v-toolbar
    data-js="get-height"
    class="toolbar--white action-bar overflow--y get-height"
    :class="{ 'action-bar--ml': !mainMenuIsOpen }"
    flat
  >
    <Breadcrumb :routes="breadcrumbItems" />

    <v-layout v-if="Boolean(selectedCompany) && !selectedItems.length" align-center row>
      <v-spacer />

      <ExportProjectAction
        v-if="claims.project['ROLE_GET_PROJECT_EXPORT'] && isValidArray(items)"
        :search="filters.search"
      />

      <router-link
        v-if="
          hasRole('company', 'ROLE_POST_COMPANY_ID_PROJECT_UPLOAD') &&
          hasRole('company', 'ROLE_POST_COMPANY_COMPANYID_BULKOPERATION_ID_EXECUTE') &&
          Boolean(selectedCompany)
        "
        :to="{ name: 'ProjectBulkOperation' }"
        :title="$t('Common.bulkImport')"
        class="action-bar__link"
      >
        {{ $t('Common.bulkImport') }}
      </router-link>

      <NewProjectAction
        v-if="claims.project['ROLE_POST_PROJECT']"
        @change="change"
      />
    </v-layout>

    <v-layout v-if="Boolean(selectedCompany) && selectedItems.length" align-center row>
      <v-spacer />

      <a
        href="#"
        :title="$t('Common.clear')"
        class="action-bar__link mr-2"
        @click.prevent="handleClearSelectedItems"
      >{{ $t('Common.clear') }}</a>

      <a
        v-if="claims.company['ROLE_DELETE_COMPANY_COMPANYID_PROJECT_MULTIDELETE']"
        href="#"
        title=""
        class="action-bar__link mr-2"
        @click.prevent="handleDeleteItems"
      >{{ $t(`${namespace}.deleteSelectedProjects`) }}</a>
    </v-layout>
  </v-toolbar>
</template>

<script>
import { mapState } from 'vuex'
import { isArray, hasRole } from 'utils/functions'
import Breadcrumb from 'components/Breadcrumb'
import ExportProjectAction from 'components/projects/ExportProjectAction'
import NewProjectAction from 'components/projects/NewProjectAction'

export default {
  name: 'ActionBar',
  props: {
    filters: {
      type: Object
    },
    items: {
      type: Array,
      required: true
    },
    selectedItems: {
      type: Array,
      required: true
    },
    noMainMenuFromV4: {
      type: Boolean,
      required: false
    }
  },
  components: {
    Breadcrumb,
    ExportProjectAction,
    NewProjectAction
  },
  computed: {
    ...mapState({
      selectedCompany: ({ company }) => company.selectedCompany,
      mainMenuIsOpen: ({ mainMenu }) => mainMenu.isOpen,
      claims: ({ userClaims }) => userClaims.claims
    })
  },
  data () {
    return {
      namespace: 'Views.ProjectsPage',
      breadcrumbItems: [
        { title: this.$t('Common.settings') },
        { name: 'Projects', title: this.$t('Views.ProjectsPage.title') }
      ]
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    hasRole (group, role) {
      return hasRole(group, role)
    },

    change (val) {
      this.$emit('change')
    },

    handleClearSelectedItems () {
      this.$emit('clearSelectedItems')
    },

    handleDeleteItems () {
      this.$emit('deleteItems', this.selectedItems)
    }
  }
}
</script>
